module.exports = __webpack_public_path__ + "img/41.c3bed1d.jpg";